<template>
	<article class="small-12 flex vertical-align tableRow border-bottom">
		<div class="tableCell small-8 flex vertical-align">
			<picture class="small-3 borderRadius4 bgOffsetGrey flex vertical-align justify-center">
				<span>jo</span>
			</picture>
			<p class="small-9 text-overflow flex vertical-align cDark">
				<b class="small-12 text-overflow cPrimaryDark">Jacob Ollmann</b>
				<span class="small-12 text-overflow cMedium">Unit: 104-B</span>
			</p>
		</div>
		<div class="tableCell small-4 flex">
			<p class="small-12 text-overflow flex justify-right vertical-align cPrimaryDark">
				+$<b>16,500</b>
			</p>
		</div>
	</article>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Renewal',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>